import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Receive from './views/Receive.vue'
import Transaction from './views/Transaction.vue'
import Send from './views/Send.vue'
import Transfer from './views/Transfer.vue'
import Receipt from './views/Receipt.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/Receive',
      name: 'Receive',
      component: Receive
    },
    {
      path: '/Transaction',
      name: 'Transaction',
      component: Transaction
    },
    {
      path: '/Send',
      name: 'Send',
      component: Send
    },
    {
      path: '/Transfer',
      name: 'Transfer',
      component: Transfer
    },
    {
      path: '/Receipt',
      name: 'Receipt',
      component: Receipt
    }
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    // }
  ]
})
